export const contentDict = {
  title: "Musio",                // Display name
  finishDate: new Date("2022-09-30"),     // format is YYYY-MM-DD
  tools: {                                // Dict of languages and percentages (should add up to 1)
    "Design Thinking": 0.25,
    "Python": 0.2,
    "C++": 0.2,
    "Electronics": 0.15,
    "ESP32": 0.1,
    "BLE": 0.05,
    "Storytelling": 0.05,
  }, 
  description: 
    `Musical cubes that help children train their hearing and learn about music through play. 
    [Think prize winning team of Think.Make.Start 2022](https://www.linkedin.com/posts/philippwulff_entrepreurship-startups-activity-6982395779516657664-pVv9?utm_source=share&utm_medium=member_desktop).`,
  tags: ["Electronics", "Hackathon"],
  github: null,    // Can also be `null`
  website: null,       // Can also be `null`
  youtube: "https://youtu.be/R5Rs-sDh5Es?t=4449",       // Can also be `null`
  images: [
    // "https://www.tms.tum.de/wp-content/uploads/2022/10/Joylab-e1665412904492.png",
    require("./kids-playing-1-720p.jpg"),
    require("./kids-playing-2-720p.jpg"),
    require("./musio-logo-transparent-720p.png"),
    require("./musio-electronics-720p.jpg"),
    require("./musio-schema.jpg"),
    require("./winning-team-2.jpg"),
  ],
  coverImg: require("./kids-playing-1-720p.jpg"),
  mainColor: "#25537a",
  authors: ["Philipp Wulff"],
  isResearch: false,    // Whether this should be in the research section
};

// export default contentDict;
// module.exports = { contentDict: 'contentDict' }